export function formatPhoneNumber(phone: number | string) {
  if (!phone) return ''
  const phoneNumber = phone.toString()

  const regexWithNine = /^(\d{2})(\d{2})(\d{1})(\d{4})(\d{4})$/
  const regexWithoutNine = /^(\d{2})(\d{2})(\d{4})(\d{4})$/

  if (regexWithNine.test(phoneNumber)) {
    return phoneNumber.replace(regexWithNine, '+$1 ($2) $3 $4-$5')
  } else if (regexWithoutNine.test(phoneNumber)) {
    return phoneNumber.replace(regexWithoutNine, '+$1 ($2) $3-$4')
  } else {
    return phone
  }
}

export function removeSpecialCharacters(number: string) {
  return number.replace(/[^0-9]+/g, '')
}

/**
 * Números móveis brasileiros migraram para 9 dígitos, mas o mesmo contato pode
 * chegar em qualquer um dos dois formatos dependendo da origem (webhook Meta,
 * contato salvo manualmente, importação). Depois que a migração terminou (2016),
 * número novo de celular pode ter qualquer dígito inicial no restante — a faixa
 * 6-9 valia só pros celulares antigos (pré-migração), então não dá mais pra usar
 * isso pra distinguir fixo de celular. Como este sistema só lida com contatos de
 * WhatsApp (fixo não tem WhatsApp), assumimos sempre celular pra número de 8 dígitos.
 */
export function getBrazilianPhoneVariants(phone: string): string[] {
  if (!/^55\d{10,11}$/.test(phone)) return [phone]

  const ddd = phone.slice(2, 4)
  const local = phone.slice(4)

  if (local.length === 9 && local[0] === '9') {
    return [phone, `55${ddd}${local.slice(1)}`]
  }
  if (local.length === 8) {
    return [phone, `55${ddd}9${local}`]
  }
  return [phone]
}

/**
 * Forma canônica pra gravar/enviar: prefere a variante de celular com 9 dígitos
 * quando existir uma. Fixo, grupo e número de outro país voltam sem alteração.
 */
export function toCanonicalBrazilianPhone(phone: string): string {
  const variants = getBrazilianPhoneVariants(phone)
  return variants.find(variant => variant.length === 13) || phone
}

export function convertToPercentage(number: number) {
  return `${number * 100}%`
}
